__turbopack_context__.v({
  "checkboxLabel": "cYKkAa_checkboxLabel",
  "container": "cYKkAa_container",
  "link": "cYKkAa_link",
});
